// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionMenuController from "./action_menu_controller"
application.register("action-menu", ActionMenuController)

import AddressLookupController from "./address_lookup_controller"
application.register("address-lookup", AddressLookupController)

import ClipboardCopyController from "./clipboard_copy_controller"
application.register("clipboard-copy", ClipboardCopyController)

import CnpjLookupController from "./cnpj_lookup_controller"
application.register("cnpj-lookup", CnpjLookupController)

import ConfirmationDialogController from "./confirmation_dialog_controller"
application.register("confirmation-dialog", ConfirmationDialogController)

import CustomerSelectionController from "./customer_selection_controller"
application.register("customer-selection", CustomerSelectionController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DocumentTemplateEditorController from "./document_template_editor_controller"
application.register("document-template-editor", DocumentTemplateEditorController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)
